module.exports = __webpack_public_path__ + "static/media/5DPO15.bccf41bb.jpg";